<template>
  <v-app>
    <app-bar> </app-bar>
    <dm-header id="home" />
    <v-content>
      <v-container class="app__container">
        <router-view class="mb-10" />
      </v-container>
    </v-content>
    <cookies />
    <dm-footer />
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar.vue';
import DmHeader from '@/components/Header.vue';
import DmFooter from '@/components/Footer.vue';
import Cookies from '@/components/Cookies.vue';

import AOS from 'aos';
import 'aos/dist/aos.css';

export default {
  name: 'App',
  components: {
    AppBar,
    DmHeader,
    DmFooter,
    Cookies,
  },
  data: () => ({
    //
  }),
  created() {
    // this.$vuetify.theme.dark = true;
    AOS.init({
      duration: 800,
    });
  },
};
</script>

<style lang="scss" scoped>
.app__container {
  max-width: 1100px !important;
}
</style>
